<template>
  <div class="main-page px-3">
    <ErrorPage v-if="!isActive" 
      code=503 
      :custom-message='inActiveMessage' 
    />    
    
    <div class="theme-tabs" v-if="isActive">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <router-link to='/discover/movies' class="nav-link" active-class="active">
            Movies</router-link>
        </li>
        <li class="nav-item">
          <router-link to='/discover/tv-shows' class="nav-link" active-class="active">
            Tv Shows</router-link>
        </li>
      </ul>
    </div>
    <!-- /.theme-tabs -->
    <div class='discv-container' v-if="isActive">
      <div class="discovertitle">
        <h2>
          Discover New
          <span v-if="$route.name == 'discover.movies'">Movies</span>
          <span v-else>TV Shows</span>
        </h2>
      </div>

      <div class="discover-page-filter">
        <form action="/" @submit.prevent="''">
          <div class="row align-items-end">
            <div class="col-12 col-sm-6 col-md-3 col-lg-4 mb-4 mb-md-0">
              <label for="year">Year</label>
              <el-select v-model="year" placeholder="Select Year" class='w-100 d-block'>
                <el-option
                  v-for="y in years"
                  :key="y"
                  :label="y"
                  :value="y">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-4 mb-4 mb-md-0">
              <label for="order">Sort by</label>
              <el-select v-model="sort" placeholder="Sort by" class='w-100 d-block'>
                <el-option
                  v-for="s in sortOptions"
                  :key="s.key"
                  :label="s.value"
                  :value="s.key">
                </el-option>
              </el-select>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-2 mb-4 mb-md-0 col-lg-2">
              <el-checkbox v-model="inTheatre">
                Only In-Theatre
              </el-checkbox>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-2">
              <label for="year" class='d-none d-sm-block'>&nbsp;</label>
              <button 
                type="button" 
                class="btn btn-secondary btn-block at-submitbtn"
                @click.prevent='refreshRoute()'
              >
                Refresh
              </button>
            </div>
          </div>
        </form>
      </div>
      <!-- /Filter Search -->

      <hr>

      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
import ErrorPage from '../../components/ErrorPage';

export default {
  data() {
    return {
      isActive: true,
      inActiveMessage: `Sorry for inconveniance! this feature from AxeTV is
        currently under maintenance and will be live soon. You will be informed once 
        it's back`,
      year: null,
      sort: null,
      inTheatre: false,
      results: [],
      refresh: 0,
    }
  },
  
  components: {
    ErrorPage
  },

  mounted() {
    this.$store.commit('bodyClass', 'bg-1');

    this.setQuery();
  },


  methods: {
    setQuery() {
      const { query } = this.$route;

      this.year = query.year || '';
      this.sort = query.sort || '';
      this.inTheatre = query.inTheatre == 'true' ? true : false;
      this.refresh = parseInt(query.refresh) || 1;

      return this;
    },

    refreshRoute() {
      this.refresh++;
      const {refresh} = this;

      this.$router.push({query : {
        ...this.$route.query,
        refresh
      }});
    }
  },


  computed: {
    years() {
      const thisYear = new Date().getFullYear();
      let years = [];

      for (let i = thisYear; i >= 1900 ; i--) {
        years.push(i);
      }

      return years;
    },

    sortOptions() {
      return [
        {
          key: 'popularity.asc',
          value: 'Popularity Asc'
        },
        {
          key: 'popularity.desc',
          value: 'Popularity Desc'
        }, 
        {
          key: 'release_date.asc',
          value: 'Release date Asc'
        }, 
        {
          key: 'release_date.desc',
          value: 'Release date Desc'
        }, 
        {
          key: 'revenue.asc',
          value: 'Revenue Asc'
        }, 
        {
          key: 'revenue.desc',
          value: 'Revenue Desc'
        }, 
        {
          key: 'primary_release_date.asc',
          value: 'Primary release date Asc'
        }, 
        {
          key: 'primary_release_date.desc',
          value: 'Primary release date Desc'
        }, 
        {
          key: 'original_title.asc',
          value: 'Original title Asc'
        }, 
        {
          key: 'original_title.desc',
          value: 'Original title Desc'
        }, 
        {
          key: 'vote_average.asc',
          value: 'Vote average Asc'
        }, 
        {
          key: 'vote_average.desc',
          value: 'Vote average Desc'
        }, 
        {
          key: 'vote_count.asc',
          value: 'Vote count Asc'
        }, 
        {
          key: 'vote_count.desc',
          value: 'Vote count Desc'
        }
      ]
    }
  },


  watch: {
    year(year) {
      this.$router.push({
        query: {
          ...this.$route.query,
          year
        }
      })
    },

    sort(sort) {
      this.$router.push({
        query: {
          ...this.$route.query,
          sort
        }
      })
    },

    inTheatre(inTheatre) {
      this.$router.push({
        query: {
          ...this.$route.query,
          inTheatre
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/inner-page-style.css';

.theme-tabs {
  padding-top: 50px;
  
  .nav-tabs {
    border: none;
    
    .nav-item {
      padding-bottom: 0px;
      padding-right: 0px;
    }

    .nav-link {
      background: #101010;
      color: white;
      padding-left: 25px;
      padding-right: 25px; 
      font-size: 15px;
      &:hover {
        border-color: transparent;
        background: #080808
      }
      &.active {
        background: #F00;
        border-color: #F00;
        color: white;
      }
    }
  }
}

.discv-container {
    background: #0a0a0ab0;
    min-height: 100px;
    border-radius: 0px 5px 5px 5px;
    padding: 25px;
}
</style>